import { Component, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle, faTimesCircle, faClock, faEllipsisVertical, faTrash } from '@fortawesome/free-solid-svg-icons';
import { LuxonModule } from 'luxon-angular';
import { YesNoMessageDialog } from '../yes-no-message-dialog/yes-no-message-dialog';

@Component({
  selector: 'app-zaehler-component',
  imports: [FontAwesomeModule, LuxonModule, YesNoMessageDialog],
  templateUrl: './zaehler-component.html',
  styleUrl: './zaehler-component.css',
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class ZaehlerComponent {
  private readonly router = inject(Router);

  readonly zaehler = input.required<any>();

  readonly faCheckCircle = faCheckCircle;
  readonly faTimesCircle = faTimesCircle;
  readonly faClock = faClock;
  readonly faEllipsisVertical = faEllipsisVertical;
  readonly faTrash = faTrash;

  readonly kuendigungDialogOpen = signal(false);
  readonly kuendigungDialogTitle = signal('Zähler kündigen');
  readonly kuendigungDialogMessage = signal('Soll der Zähler');
  readonly actionsMenuOpen = signal(false);

  getStatusClass(genehmigt: boolean | null | undefined): string {
    if (genehmigt === true) return 'bg-green-50';
    if (genehmigt === false) return 'bg-red-50';
    return 'bg-blue-50';
  }

  getStatusLabel(genehmigt: boolean | null | undefined): string {
    if (genehmigt === true) return 'Genehmigt';
    if (genehmigt === false) return 'Abgelehnt';
    return 'In Bearbeitung';
  }

  getStatusIcon(genehmigt: boolean | null | undefined) {
    if (genehmigt === true) return this.faCheckCircle;
    if (genehmigt === false) return this.faTimesCircle;
    return this.faClock;
  }

  getStatusBadgeClass(genehmigt: boolean | null | undefined): string {
    if (genehmigt === true) return 'bg-green-100 text-green-700';
    if (genehmigt === false) return 'bg-red-100 text-red-700';
    return 'bg-blue-100 text-blue-700';
  }

  onAblesungEintragen(zaehlerId: string | undefined) {
    this.router.navigate(['/neueZaehlerAblesung', zaehlerId]);
  }

  toggleActionsMenu(): void {
    this.actionsMenuOpen.update((isOpen) => !isOpen);
  }

  closeActionsMenu(): void {
    this.actionsMenuOpen.set(false);
  }

  onMenuKundigen(): void {
    this.closeActionsMenu();
    this.onZaehlerKundigen();
  }

  onZaehlerKundigen() {
    this.closeActionsMenu();
    this.kuendigungDialogTitle.set('Zähler kündigen');
    this.kuendigungDialogMessage.set(
      'Soll der Zähler mit der Nummer "' +
        this.zaehler().zaehlernummer +
        '" wirklich gekündigt werden?',
    );
    this.kuendigungDialogOpen.set(true);
  }

  onKundigungDialogClosed(event: any) {
    console.debug('Event: ', event);
    this.kuendigungDialogOpen.set(false);
    if (event) {
      console.debug('Dialog confirmed: ', event);
    }
  }

  onDocumentClick(event: MouseEvent): void {
    if (!this.actionsMenuOpen()) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) {
      this.closeActionsMenu();
      return;
    }

    if (target.closest('[data-actions-menu-container]')) {
      return;
    }

    this.closeActionsMenu();
  }
}
